import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Button as DSButton } from '@hvcgroep/design-system';
import { Props as DSProps } from '@hvcgroep/design-system/dist/components/Button/index';

import { APP_ID } from '../../config/constants';
import gtm from '../../helpers/gtm';

type BaseProps = DSProps & {
  noTracking?: boolean;
};

const Button = React.forwardRef<HTMLButtonElement, BaseProps>((props, ref) => {
  const {
    noTracking,
    children,
    onClick,
  } = props;

  const clickFunction = (e: React.MouseEvent<any, MouseEvent>) => {
    // Send tracking event to GTM.
    if (!noTracking) {
      gtm.trackUserEvent(String(APP_ID), 'Button click', children);
    }

    // Fire the onClick function if present.
    if (onClick) onClick(e);
  };

  return (
    <DSButton
      {...props}
      ref={ref}
      onClick={clickFunction}
    >
      {children}
    </DSButton>
  );
});

export default Button;
